<template>
    <div id="boot-screen">
        <div class="login-view row m-0">
            <div class="col-sm-9 col-md-7 col-lg-6 col-xl-5 col-xxl-4">
                <div class="card card-body p-4 shadow m-4">
                    <img
                        src="/icon.svg"
                        class="logo mb-3 mx-auto d-block"
                    />
                    <h1 class="m-0 mb-4 text-center">{{ message }}</h1>

                    <div class="d-flex justify-content-center">
                        <i class="fa-solid fa-circle-notch fa-spin fa-3x text-primary"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
#boot-screen {
    z-index: 10000;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>

<script>
import { useUserStore } from "@stores/userStore";

export default {
    name: "BootScreen",
    emits: ["loaded"],
    setup() {
        const userStore = useUserStore();
        return { userStore };
    },
    data() {
        return {
            message: "Welkom bij YHub!",
        };
    },
    watch: {
        async "userStore.loaded"() {
            this.handleLoaded();
        },
    },
    mounted() {
        if (this.userStore.loaded) {
            this.handleLoaded();
        }
    },
    methods: {
        handleLoaded() {
            setTimeout(() => {
                this.$emit("loaded");
            }, 1500);

            setTimeout(async () => {
                if ((await this.userStore.getActiveUserType) !== "guest") {
                    this.message = "Welkom " + this.userStore.getFirstname + "!";
                } else {
                    this.message = "Laden voltooid!";
                }
            }, 500);
        },
    },
};
</script>
